import React from 'react';

export const SvgThumbsDown = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.1456 12.6501L12.5456 18.5C12.0285 18.5 11.5325 18.2946 11.1668 17.9289C10.8011 17.5632 10.5957 17.0672 10.5957 16.55V13.9501H6.91675C6.72831 13.9522 6.54166 13.9134 6.36974 13.8362C6.19781 13.759 6.04471 13.6454 5.92106 13.5032C5.7974 13.361 5.70614 13.1936 5.6536 13.0126C5.60106 12.8317 5.58849 12.6414 5.61677 12.4551L6.51376 6.60521C6.56076 6.29523 6.71822 6.01268 6.95711 5.80963C7.196 5.60657 7.50022 5.49669 7.81373 5.50023H15.1456M15.1456 12.6501V5.50023M15.1456 12.6501H16.8811C17.2489 12.6566 17.6064 12.5278 17.8856 12.2882C18.1648 12.0485 18.3462 11.7147 18.3955 11.3501V6.80021C18.3462 6.43561 18.1648 6.1018 17.8856 5.86216C17.6064 5.62252 17.2489 5.49373 16.8811 5.50023H15.1456"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
